import instagram from "../Assets/Instagram.png"
import linkedin from "../Assets/Linkedin.png"
import youtube from "../Assets/Youtube.png"
import pinterest from "../Assets/Pinterest.png"
import facebook from "../Assets/FaceBook.png"
import twitter from "../Assets/Twitter.png"
const Footer=()=>
{
    const logos=[
        {"logo":facebook,"url":"https://www.facebook.com/brikitt"},
        {"logo":instagram,"url":"https://www.instagram.com/brik_itt/"},
        {"logo":twitter,"url":"https://twitter.com/brik_itt"},
        {"logo":linkedin,"url":"https://www.linkedin.com/company/brikitt/"},
        {"logo":youtube,"url":"https://www.youtube.com/channel/UC87MapL09nu9jrH_5atRdQw"}]
    return(
        <div className="sm:block lg:flex flex-row-reverse justify-between items-center sm:px-[80px] sm:py-[23px] lg:px-[160px] lg:py-[25px] bg-[#302413]">
            
            <div className="flex sm:justify-center items-center gap-[27px]">
                {
                    logos?.map((e,i)=>
                    {
                        return(
                            <a href={e.url} target="blank">
                                <img src={e.logo} key={i} />
                            </a>
                        )
                    })
                }
            </div>
            {/* <div className="sm:flex-col sm:mt-[20px] lg:mt-[0px] sm:text-center lg:flex lg:flex-row gap-[20px] text-[12px] text-white font-[400] leading-[16px] tracking-[0.5px]">
                <a>Help</a><br/>
                <a>Support and Contact</a>
            </div> */}
            <p style={{fontFamily:"Inter"}} className="sm:text-[11px] lg:text-[12px] text-white font-[400] leading-[16px] tracking-[0.5px] sm:mt-[20px] lg:mt-[0px] sm:text-center">© 2023 BRIK itt Proptech Pvt.Ltd.</p>
        </div>
    )
}
export default Footer